import {
  generateGetAction, generatePostAction,
} from '@services/ActionDispatcher';

import {
  onboardingDataAction, getSpecialtiesAction, getServicesAction,
  getAllergiesAction, getSpecialConsiderationsAction, getSedationsAction,
  getProvincesAction, sendInvitationAction, getSpecialtiesAndServicesAction,
  getUnreadNotificationsAction, getLabServicesAction,
} from './SharedActionConfig';

const onboardingDataRequest = () => generateGetAction(
  // action name
  onboardingDataAction,
  // url
  'user/profile/onboarding',
);

const getSpecialtiesRequest = (queryParams: any) => generateGetAction(
  // action name
  getSpecialtiesAction,
  // url
  'specialties',
  {
    queryParams: {
      limit: 200,
      ...(queryParams || {}),
    },
  },
);

const getServicesRequest = (queryParams: any) => generateGetAction(
  // action name
  getServicesAction,
  // url
  'services',
  {
    queryParams: {
      limit: 200,
      ...(queryParams || {}),
    },
  },
);

const getAllergiesRequest = () => generateGetAction(
  // action name
  getAllergiesAction,
  // url
  'allergies',
);

const getSpecialConsiderationsRequest = () => generateGetAction(
  // action name
  getSpecialConsiderationsAction,
  // url
  'special-considerations',
);

const getSedationsRequest = () => generateGetAction(
  // action name
  getSedationsAction,
  // url
  'sedations',
);

const getProvincesRequest = (queryParams: any) => generateGetAction(
  // action name
  getProvincesAction,
  // url
  'provinces',
  {
    queryParams: {
      limit: 200,
      ...(queryParams || {}),
    },
  },
);

const sendInvitationRequest = (data: any) => generatePostAction(
  // action name
  sendInvitationAction,
  // url
  'invitation',
  data,
);

const getSpecialtiesAndServicesRequest = () => generateGetAction(
  // action name
  getSpecialtiesAndServicesAction,
  // url
  'specialties-services',
);

const getUnreadNotificationsRequest = (params?: any) => generateGetAction(
  // action name
  getUnreadNotificationsAction,
  // url
  'unread-notifications',
  {
    queryParams: params,
  },
);

const getLabServicesRequest = (params: any) => generateGetAction(
  // action name
  getLabServicesAction,
  // url
  'laboratory-services',
  {
    queryParams: params,
  },
);

export {
  // eslint-disable-next-line import/prefer-default-export
  onboardingDataRequest,
  getSpecialtiesRequest,
  getServicesRequest,
  getAllergiesRequest,
  getSpecialConsiderationsRequest,
  getSedationsRequest,
  getProvincesRequest,
  sendInvitationRequest,
  getSpecialtiesAndServicesRequest,
  getUnreadNotificationsRequest,
  getLabServicesRequest,
};
